<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          v-card(flat)
            v-card-text.label16tt.withDivider
              | LECCIÓN: ELIGE TU CRÉDITO HIPOTECARIO
            v-card-text.titulo36Book
              | ¿Estoy listo/a para cursar esta lección?
            p(text-xs-start)
              img(style='width:100%;', src='assets/TCH-L2.1-portada.jpg')
              .parrafoDestacado18
                | La siguiente actividad, es una evaluación de tus conocimientos sobre aspectos generales de crédito. El objetivo es que valores si estás listo/a para aprovechar al máximo la experiencia de aprendizaje contenida en esta lección.
            v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextPage('page1-2')")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    }
  }
};
</script>
